import React from 'react';
import MuiIconButton from '@mui/material/IconButton';
import { DashboardIcon, DashboardIconType } from './DashboardIcon';

type IconButtonProps = {
  ariaLabel: string;
  icon?: DashboardIconType;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  title?: string;
  type?: 'button' | 'submit' | 'reset';
};

export function IconButton({
  ariaLabel,
  children,
  className = 'btn-icon borderless',
  disabled = false,
  icon,
  onClick,
  title,
  type = 'button',
}: IconButtonProps) {
  return (
    <MuiIconButton
      aria-label={ariaLabel}
      className={className}
      disabled={disabled}
      onClick={onClick}
      size="small"
      title={title}
      type={type}
    >
      {icon ? <DashboardIcon type={icon} /> : children}
    </MuiIconButton>
  );
}
